class Gallery {
  constructor() {
    const that = this;

    this.galleryInstances = {};

    let body = $('.body');
    let page = null;

    $('.js-gallery').each((index, element) => {
      let $container = $(element);

      // Add class index
      $container.addClass(`gallery-${index}`);
      $container.find('.gallery-pagination').addClass(`gallery-pagination-${index}`);

      let swiper = new Swiper(`.gallery-${index}`, {
        slideClass: 'swiper-slide',
        wrapperClass: 'swiper-wrapper',
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        effect: 'fade',
        pagination: {
          el: `.gallery-pagination-${index} .slide-counter`,
          clickable: true,
          type: 'fraction'
        },
        navigation: {
          nextEl: `.gallery-pagination-${index} .swiper-button-next`,
          prevEl: `.gallery-pagination-${index} .swiper-button-prev`
        },
      });

      $('.js-open-gallery').on('click', function(e) {
        e.preventDefault();

        let button = $(this);

        swiper.removeAllSlides();

        body.addClass('-menu-opened');

        page = button.closest('.page');
        page.find('.gallery').addClass('-active');

        $('html, body').animate({
          scrollTop: page.offset().top
        }, 400);

        window.setTimeout(function() {
          page.addClass('-gallery-active');

          fetch(button.data('gallery'))
            .then(response => response.json())
            .then(resp => {
              if(resp.success == true) {
                let data = resp.data;
                let photos = [];

                data.filter( function( result, i, data ) {
                  photos.push(that.galleryTemplate(result));
                });

                if (photos.length <= 1) {
                  page.find('.gallery .slide-pagination').addClass('sr-only');
                } else {
                  page.find('.gallery .slide-pagination').removeClass('sr-only');
                }

                swiper.appendSlide(photos);

                swiper.update();

                window.setTimeout(function() {
                  swiper.slideTo(0);
                }, 400);
              }
            })
            .catch(err => {
              console.error(err);
          });
        }, 400);
      });

      $('.js-close-gallery').on('click', function(e) {
        e.preventDefault();

        body.removeClass('-menu-opened');
        page = $(this).closest('.page');

        page.find('.gallery').removeClass('-active');
        page.removeClass('-gallery-active');

        swiper.removeAllSlides();
      });
    });
  }

  galleryTemplate(result) {
    let details = result.details.split('|');

    return `<article class="photo swiper-slide">
              <div class="photo-content">
                <div class="photo-caption">
                  <div class="container">
                    <div class="row">
                      <div class="col-sm-2 col-sm-push-6">
                        <span class="photo-category text -default f-c10">${result.category}</span>
                      </div>
                      <div class="col-sm-4 col-sm-pull-2 col-sm-offset-2 f-h">
                        <h3 class="title f-averia f-c10">${result.title}</h3>
                        <p class="text -paragraph f-times f-c10"><span class="text-intro">${details[0]}</span> ${details.slice(1).join('')}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="photo-figure">
                  <div data-rellax-percentage="0.5" class="photo-image bg-cover bg-overlay" style="background-image: url('${result.image}');"></div>
                </div>
              </div>
            </article>`;
  }
}

export default Gallery;
